import axios from 'axios';

export const onboardRoxUser = (msisdn) => {
  axios.get(`${process.env.REACT_APP_ROX_BASE_URL}/v1/rox/onboard`, {
    params: { msisdn, onboarding: 'done' },
  }).catch(() => {});
};
